export default "__VITE_ASSET__wjSrB11H__"